import styled from 'styled-components';
import { StyleLessButton} from "../commonStyles";

export const StyledPrintButton = styled(StyleLessButton)`
  display: flex;
  align-items: center;
`;

export const StyledPrintLabel = styled.div`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: 0;
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  display: block;
  @media only screen and (min-width: 992px) {
    font-size: ${props => props.theme.fontSize.primary};
  }
`;